import service from './backend';

function install (Vue, options) {
  const api = service(options)
  Vue.api = api
  Vue.prototype.$api = api
}

export default {
  install
}

